export class UserDetails {
    public facilityUserID: number;
    public facilityID: number;
    public authUserID: number;
    public userLastName: string;
    public userFirstName: string;
    public userEmail: string;
    public activeYN: boolean;
    public roleID: number;
    public role: string;
    public backupSC: boolean;
    public allowEditPermissions: boolean;    
    public allowEditRole: boolean;
    public lastLoginDate: string;
    public mainMenuAccess: MainMenuAccess;
    public dataEntryAccess: DataEntryAccess;
    public activeStatus: boolean; //"activeStatus" is used to keep the activity chkbx status after saved, when user-dropdown is changed (w/o refreshing).
    

    constructor(facilityUserID: number, facilityID: number, authUserID: number, userLastName: string, userFirstName: string,
                userEmail: string, activeYN: boolean, roleID: number, role: string, backupSC: boolean, 
                allowEditPermissions: boolean, allowEditRole: boolean, lastLoginDate: string,
                mainMenuAccess: MainMenuAccess,  dataEntryAccess: DataEntryAccess, 
                activeStatus: boolean ) {
        this.facilityUserID = facilityUserID;
        this.facilityID = facilityID;
        this.authUserID = authUserID;
        this.userLastName = userLastName;
        this.userFirstName = userFirstName;
        this.userEmail = userEmail;
        this.activeYN = activeYN;
        this.roleID = roleID;
        this.role = role;
        this.backupSC = backupSC;
        this.allowEditPermissions = allowEditPermissions;
        this.allowEditRole = allowEditRole;
        this.lastLoginDate = lastLoginDate;
        this.mainMenuAccess = mainMenuAccess;
        this.dataEntryAccess = dataEntryAccess;
        this.activeStatus = activeStatus
    }

    get FacilityUserID(): number { return this.facilityUserID; }

    get FacilityID(): number { return this.facilityID; }
    set FacilityID(value: number) { this.facilityID = value; }

    get AuthUserID(): number { return this.authUserID; }
    set AuthUserID(value: number) { this.authUserID = value; }
    
    get UserLastName(): string { return this.userLastName; }
    set UserLastName(value: string) { this.userLastName = value; }

    get UserFirstName(): string { return this.userFirstName; }
    set UserFirstName(value: string) { this.userFirstName = value; }

    get UserEmail(): string { return this.userEmail; }
    set UserEmail(value: string) { this.userEmail = value; }

    get ActiveYN(): boolean { return this.activeYN; }
    set ActiveYN(value: boolean) { this.activeYN = value; }

    get RoleID(): number { return this.roleID; }
    set RoleID(value: number) { this.roleID = value; }

    get Role(): string { return this.role; }
    set Role(value: string) { this.role = value; }

    get BackupSC(): boolean { return this.backupSC; }
    set BackupSC(value: boolean) { this.backupSC = value; }

    get AllowEditPermissions(): boolean { return this.allowEditPermissions; }
    set AllowEditPermissions(value: boolean) { this.allowEditPermissions = value; }

    get AllowEditRole(): boolean { return this.allowEditRole; }
    set AllowEditRole(value: boolean) { this.allowEditRole = value; }
    
    get LastLoginDate(): string { return this.lastLoginDate; }
    set LastLoginDate(value: string) { this.lastLoginDate = value; }

    
    get ActiveStatus(): boolean { return this.activeStatus; }
    set ActiveStatus(value: boolean) { this.activeStatus = value; }

    
}

interface MainMenuPermission {
    facilityUserID: number;
    indicatorID: number;
    indicator: string;
    authorized: boolean;
    tutExists: boolean;
    tutPassed: boolean;
    tutDate: string | null;
    alwaysAuthorized: boolean;
  }
  
  interface DataEntryPermission {
    facilityUserID: number;
    indicatorID: number;
    indicator: string;
    authorized: boolean;
    tutExists: boolean;
    tutPassed: boolean;
    tutDate: string | null;
    alwaysAuthorized: boolean;
  }
  
  export interface MainMenuAccess {
    permissions: MainMenuPermission[];
  }
  
  export interface DataEntryAccess {
    permissions: DataEntryPermission[];
  }
